import React from 'react';

import L2Page from '../../../../templates/l2-page';

import Content from './_index.mdx';

export default () => {
	return (
		<L2Page
			categorySlug="voice-tone"
			title="Voice and tone"
			description="How to create content that aligns with the Atlassian voice and tone."
			entries={[]}
		>
			<Content />
		</L2Page>
	);
};
